<template>
  <Layout>
    <template slot="body">
      <Scores v-if="acao == 'kpi'" :estadoini="estado" @mapa="acao = 'brasil'"></Scores>
      <Brasil v-show="acao == 'brasil'" @selecionar="selecionar"></Brasil>
    </template>
  </Layout>
</template>

<script>
// @ is an alias to /src
import Layout from "@/components/layout/Layout.vue";
import Scores from "@/components/ScoresAnaliseMunicipios.vue";
import Brasil from "@/components/Brasil.vue";
export default {
  name: "Home",
  data() {
    return {
      acao: "brasil",
      estado: null
    };
  },
  methods: {
    selecionar(estado) {
      this.estado = estado;
      this.acao = 'kpi';
    },
  },
  components: {
    Layout,
    Scores,
    Brasil,
  },
};
</script>
